export default __webpack_public_path__ + "static/media/DP3 2A-1E.a0d78db2.jpg";